import { render } from "./Advanced.vue?vue&type=template&id=c1774968&scoped=true"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"

import "./Advanced.vue?vue&type=style&index=0&id=c1774968&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1774968"]])

export default __exports__